import { ImageSlice } from '@monofront/types';
import ImageBase from '@slices/Image';

const Image = ({ prismicContent }: { prismicContent: ImageSlice }) => {
  return <ImageBase {...prismicContent} />;
};

export default Image;
